import { render } from "./CopyReleaseLinkButton.vue?vue&type=template&id=0c59fb7a"
import script from "./CopyReleaseLinkButton.vue?vue&type=script&lang=js"
export * from "./CopyReleaseLinkButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__